// API Configuration
const getApiBaseUrl = () => {
  // Priority 1: Runtime detection - check if we're running on production domain
  // This MUST be checked first to ensure it works even if NODE_ENV wasn't set correctly during build
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const pathname = window.location.pathname;
    const origin = window.location.origin;
    
    // Check if we're on production domain (ptthaiplus.com)
    if (hostname.includes('ptthaiplus.com') || hostname.includes('ptthaiplus')) {
      return 'https://www.ptthaiplus.com/ptthaiplus_app/api';
    }
    
    // Check if pathname includes /ptthaiplus_app (production path)
    if (pathname.includes('/ptthaiplus_app')) {
      return 'https://www.ptthaiplus.com/ptthaiplus_app/api';
    }
    
    // Check if origin is production (not localhost or 127.0.0.1)
    if (origin && !origin.includes('localhost') && !origin.includes('127.0.0.1') && !origin.includes('192.168.') && !origin.includes('10.0.')) {
      // If we're not on localhost, assume production and use production URL
      return 'https://www.ptthaiplus.com/ptthaiplus_app/api';
    }
  }
  
  // Priority 2: Use REACT_APP_API_URL if set
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.endsWith('/api') 
      ? process.env.REACT_APP_API_URL 
      : `${process.env.REACT_APP_API_URL}/api`;
  }
  
  // Priority 3: Check if we're in production (react-scripts sets NODE_ENV=production during build)
  if (process.env.NODE_ENV === 'production') {
    // In production, use the production API URL
    return 'https://www.ptthaiplus.com/ptthaiplus_app/api';
  }
  
  // Priority 4: Development fallback (only for localhost)
  return 'http://localhost:3001/api';
};

const getSocketUrl = () => {
  // Priority 1: Runtime detection - check if we're running on production domain
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const pathname = window.location.pathname;
    const origin = window.location.origin;
    
    // Check if we're on production domain (ptthaiplus.com)
    if (hostname.includes('ptthaiplus.com') || hostname.includes('ptthaiplus')) {
      return 'https://www.ptthaiplus.com';
    }
    
    // Check if pathname includes /ptthaiplus_app (production path)
    if (pathname.includes('/ptthaiplus_app')) {
      return 'https://www.ptthaiplus.com';
    }
    
    // Check if origin is production (not localhost or 127.0.0.1)
    if (origin && !origin.includes('localhost') && !origin.includes('127.0.0.1') && !origin.includes('192.168.') && !origin.includes('10.0.')) {
      // If we're not on localhost, assume production and use production URL
      return 'https://www.ptthaiplus.com';
    }
  }
  
  // Priority 2: Use REACT_APP_SOCKET_URL if set
  if (process.env.REACT_APP_SOCKET_URL) {
    return process.env.REACT_APP_SOCKET_URL;
  }
  
  // Priority 3: Production: use same domain
  if (process.env.NODE_ENV === 'production') {
    return 'https://www.ptthaiplus.com';
  }
  
  // Priority 4: Development: use localhost
  return 'http://localhost:3001';
};

// Export functions instead of evaluated values to ensure runtime detection works
export const API_CONFIG = {
  get BASE_URL() {
    return getApiBaseUrl();
  },
  get SOCKET_URL() {
    return getSocketUrl();
  },
  TIMEOUT: 30000, // 30 seconds
  RETRY_ATTEMPTS: 3
};

// API endpoints
export const API_ENDPOINTS = {
  // Auth
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    PROFILE: '/auth/profile'
  },
  
  // Clients
  CLIENTS: {
    LIST: '/clients',
    DETAIL: '/clients/:id',
    CREATE: '/clients',
    UPDATE: '/clients/:id',
    DELETE: '/clients/:id'
  },
  
  // Workouts
  WORKOUTS: {
    LIST: '/workouts/client/:clientId',
    CREATE: '/workouts',
    UPDATE: '/workouts/:id',
    DELETE: '/workouts/:id',
    CHECKIN: '/workouts/:id/checkin',
    CHECKOUT: '/workouts/:id/checkout'
  },
  
  // Exercises
  EXERCISES: {
    LIST: '/exercises',
    DETAIL: '/exercises/:id',
    CREATE: '/exercises',
    UPDATE: '/exercises/:id',
    DELETE: '/exercises/:id',
    METADATA: '/exercises/meta/categories'
  },
  
  // Packages
  PACKAGES: {
    LIST: '/packages',
    DETAIL: '/packages/:id',
    CREATE: '/packages',
    UPDATE: '/packages/:id',
    DELETE: '/packages/:id'
  },
  
  // Body Measurements
  BODY_MEASUREMENTS: {
    LIST: '/body-measurements/client/:clientId',
    CREATE: '/body-measurements',
    UPDATE: '/body-measurements/:id',
    DELETE: '/body-measurements/:id',
    STATS: '/body-measurements/client/:clientId/stats'
  },
  
  // Nutrition Plans
  NUTRITION_PLANS: {
    LIST: '/nutrition-plans/client/:clientId',
    ACTIVE: '/nutrition-plans/client/:clientId/active',
    CREATE: '/nutrition-plans',
    UPDATE: '/nutrition-plans/:id',
    DELETE: '/nutrition-plans/:id'
  },
  
  // Chat
  CHAT: {
    ROOMS: '/chat/rooms',
    MESSAGES: '/chat/rooms/:roomId/messages',
    SEND_MESSAGE: '/chat/rooms/:roomId/messages',
    READ_MESSAGE: '/chat/messages/:messageId/read',
    DELETE_MESSAGE: '/chat/messages/:messageId',
    HEALTH: '/chat/health'
  }
};

// Export getApiBaseUrl function for direct use
export { getApiBaseUrl, getSocketUrl };

export default API_CONFIG;
